const deleteRegionAPI = async (regionId) => {
  let response = await fetch(`${process.env.REACT_APP_API_URL}/Regions/DeleteRegion/${regionId}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
  }).catch((err) => {
    console.log(err);
  });

  return response.status;
};

export default deleteRegionAPI;
